import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class KapacitetLinijaService {
  constructor(private _http: HttpClient) {}

  dohvatiSveLinije(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_linije', a)
      .pipe(map((res: any) => res));
  }

  dohvatiJednuLiniju(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_liniju', a)
      .pipe(map((res: any) => res));
  }

  dodajLiniju(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'linija_spremi', a)
      .pipe(map((res: any) => res));
  }

  urediLiniju(a: any) {
    return this._http
      .put(AppConfig.ipAddress + 'linija_uredi', a)
      .pipe(map((res: any) => res));
  }

  obrisiLiniju(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'linija_obrisi', a)
      .pipe(map((res: any) => res));
  }

  dohvatiLiniju(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_jednu_liniju', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveProizvode(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_artikle', a)
      .pipe(map((res: any) => res));
  }

  spremiProizvod(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'spremi_proizvod_linija', a)
      .pipe(map((res: any) => res));
  }

  urediProizvod(a: any) {
    return this._http
      .put(AppConfig.ipAddress + 'proizvod_uredi', a)
      .pipe(map((res: any) => res));
  }

  obrisiProizvod(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'proizvod_delete', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSkladista(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_skladista_pekar', a)
      .pipe(map((res: any) => res));
  }

  dohvatiDjelatnike(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_djelatnike', a)
      .pipe(map((res: any) => res));
  }

  dohvatiDjelatnikeNaLiniji(a: any) {
    return this._http
    .post(AppConfig.ipAddress + 'linijaodgovornaosobaPopisSviPlusOznaceni', a)
    .pipe(map((res: any) => res));
  }

  pogoni(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'pogoni', a)
      .pipe(map((res: any) => res));
  }

  // maksimalniKapacitetLinija() {
  //   return linije;
  // }
}

// export class Linije {
//   sifra: number;
//   naziv: string;
//   maksimum: number;
// }

// let linije: Linije[] = [{
//   "sifra": 100575,
//   "naziv": "Burek s junetinom 250g zamrznuti",
//   "maksimum": 0
// },
// {
//   "sifra": 612351,
//   "naziv": "Kruh domaći pogača 300g zamrznuti",
//   "maksimum": 0
// },
// {
//   "sifra": 321452,
//   "naziv": "Kruh polubijeli pšen, rezani 1kg",
//   "maksimum": 1500
// }]
